// extracted by mini-css-extract-plugin
module.exports = {"paste-options":"src-modules-directives-pasteOptions---paste-options"};